import DataTable, { ExpanderComponentProps }from "react-data-table-component"
import PropTypes from 'prop-types';
import Loader from "../loader";
import "./table.scss";
import Pagination from "../pagination";

const ExpandedComponent = ({ data }) => {
    return (
        <pre style={{ margin: 0 }}>
            {JSON.stringify(data, null, 2)}
        </pre>
    );
};


const Table = (props) => {
    return (
        <div className="mt-4">
            <div className="table-wrap table-fixed-2">
                {
                    props.isLoading ?
                        <Loader /> :
                        //     props.error === '' ?
                        <>
                            <DataTable
                                selectableRows
                                onSelectedRowsChange={props.handleChangeSelect}
                                selectableRowsComponentProps={{ className: 'custom-checkbox' }}
                                columns={props.columns}
                                footer={props.columns}
                                data={props.data}
                                persistTableHead
                            />
                        </>
                    // :
                    // <p className="text-center">{props.error}</p>
                }


            </div>
            {/* <div className="mt-3 d-flex justify-content-between mt-3" style={{
                zIndex: 0,
                position: 'relative',
            }}>
                <Select
                    onChange={props.handleLimit}
                    value={props.filter.limit}
                    data={[
                        {
                            id: 10,
                            name: '10'
                        },
                        {
                            id: 20,
                            name: '20'
                        },
                        {
                            id: 30,
                            name: '30'
                        },
                    ]} />
                </div> */}
            {
                props.error === '' && props.totalPages > 1 ?
                    <Pagination
                        currentPage={props.filter.page - 1}
                        pageCount={props.totalPages}
                        handlePaginate={props.handlePagination} />
                    : null
            }
        </div>
    )
}
export default Table
Table.propTypes = {
    _id: PropTypes.string,
    columns: PropTypes.array,
    url: PropTypes.string,
    urlParams: PropTypes.string,
    isUpdate: PropTypes.bool,
    init: PropTypes.bool,
    handleChangeSelect: PropTypes.func,
    handlePagination: PropTypes.func,
    handleLimit: PropTypes.func,
    filter: PropTypes.any,
    data: PropTypes.any,
    totalPages: PropTypes.number,
    totalData: PropTypes.number,
};
Table.defaultProps = {
    urlParams: '',
}
